import CopiedAlert from "pages/components/CopyAlert";
import React, { useState } from "react";
import { Col, Row, Button } from 'react-bootstrap';
import Select from 'react-select';

export const APIComponent = () => {
    const userObject = JSON.parse(localStorage.getItem("TOKEN"));
    const token = userObject.token;

    const [showAlert, setShowAlert] = useState(false);
    const [text, setText] = useState(false);

    const [code, setCode] = useState({ addAPI: 'cURL', churnAPI: 'cURL' });
    const handleCode = (selectedOption, actionMeta) => {
        setCode({
            ...code,
            [actionMeta.name]: selectedOption.value
        });
    };

    const addCurl = `curl --location 'https://mat.blockcube.co/api/upload_list?list_name=my_api_list&remark=testing1&msisdn=9818049959' \
    --header 'Authorization: ${token}'`;
    const addHttp = `GET /api/upload_list?list_name=my_api_list&remark=testing1&msisdn=9818049959 HTTP/1.1
    Host: mat.blockcube.co
    Authorization: ${token}`;

    const churnCurl = `curl --location 'https://mat.blockcube.co/api/churn_list?list_name=my_api_list&msisdn=9818049959' \
    --header 'Authorization: ${token}'`;
    const churnHttp = `GET /api/churn_list?list_name=my_api_list&msisdn=9818049959 HTTP/1.1
    Host: mat.blockcube.co
    Authorization: ${token}`;

    const copyToClipboard = (e) => {
        if (e.target.id === 'code1') {
            if (code.addAPI === 'cURL') {
                navigator.clipboard.writeText(addCurl).then(() => {
                    setShowAlert(true);
                });
            } else if (code.addAPI === 'HTTP') {
                navigator.clipboard.writeText(addHttp).then(() => {
                    setShowAlert(true);
                });
            }
            setText('Copied ADD API');
        } else if (e.target.id === 'code2') {
            if (code.churnAPI === 'cURL') {
                navigator.clipboard.writeText(churnCurl).then(() => {
                    setShowAlert(true);
                });
            } else if (code.churnAPI === 'HTTP') {
                navigator.clipboard.writeText(churnHttp).then(() => {
                    setShowAlert(true);
                });
            }
            setText('Copied CHURN API');
        }
    };

    const apiOptions = [
        { value: 'cURL', label: 'cURL' },
        { value: 'HTTP', label: 'HTTP' }
    ];

    return (
        <Row>
            <CopiedAlert showAlert={showAlert} setShowAlert={setShowAlert} value={text} />
            <Col sm={6}>
                <div className="d-flex justify-content-between mb-2">
                    <p className="h6 card-text">ADD API</p>
                    <Select
                        options={apiOptions}
                        value={apiOptions.find(option => option.value === code.addAPI)}
                        onChange={handleCode}
                        name="addAPI"
                        className="fix-200 p-2"
                        style={{
                            container: (provided) => ({
                                ...provided,
                                minWidth: "200px",
                                maxWidth: "250px",
                              }),
                        }}
                    />
                </div>
                <pre style={{ height: '200px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#f8f9fa', padding: '10px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
                    {code.addAPI === 'HTTP' ? addHttp : addCurl}
                </pre>
                <Button onClick={copyToClipboard} id="code1" title="Copy to Clipboard" variant="secondary" style={{ marginTop: '10px' }}>
                    Copy
                </Button>
            </Col>

            <Col sm={6} className="mt-4 mt-sm-0">
                <div className="d-flex justify-content-between mb-2">
                    <p className="h6 card-text">CHURN API</p>
                    <span>
                    <Select
                        options={apiOptions}
                        value={apiOptions.find(option => option.value === code.churnAPI)}
                        onChange={handleCode}
                        name="churnAPI"
                        className="fix-200 p-2"
                        style={{
                            container: (provided) => ({
                                ...provided,
                                minWidth: "200px",
                                maxWidth: "250px",
                              }),
                        }}
                    />
                    </span>
                </div>
                <pre style={{ height: '200px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#f8f9fa', padding: '10px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
                    {code.churnAPI === 'HTTP' ? churnHttp : churnCurl}
                </pre>
                <Button onClick={copyToClipboard} id="code2" title="Copy to Clipboard" variant="secondary" style={{ marginTop: '10px' }}>
                    Copy
                </Button>
            </Col>
            <Col xs={12} className="mt-4">
            <a href={`${process.env.REACT_APP_API_PORT}/download_contact_list_sample`} className="m-0"><b>Note:</b> Kindly refer to <u>this Sample File</u> for headers and add headers using <b>&header=value</b>.</a>
            </Col>
        </Row>
    )
}